exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".block.m-5 {\n  margin-bottom: 5px; }\n\n.block.m-10 {\n  margin-bottom: 10px; }\n\n.block.m-15 {\n  margin-bottom: 15px; }\n\n.block.m-20 {\n  margin-bottom: 20px; }\n\n.block.m-30 {\n  margin-bottom: 30px; }\n\n.block.m-40 {\n  margin-bottom: 40px; }\n\n.block.m-50 {\n  margin-bottom: 50px; }\n\n.block.m-80 {\n  margin-bottom: 80px; }\n\n.block.m-100 {\n  margin-bottom: 100px; }\n\n.block.m-150 {\n  margin-bottom: 150px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/layout/Block/index.scss
// module id = 635
// module chunks = 0